import React from 'react';
import classNames from 'classnames';
import styles from './PremiumBenefits.module.scss';
import Button from '../../Button/Button';
import { ButtonAppearance, IconPosition } from '../../ButtonBase/types';
import { IconGlyph } from '../../Icon';
import BenefitsList from './BenefitsList/BenefitsList';
import { Phrases } from '../../../utilities/constants/phrases';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import Title from '../../TitleWithGradient/TitleWithGradient';
import { useOpenSubscriptionPopup } from '../../../hooks/popup/useOpenSubscriptionPopup';

export enum TitleVersion {
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
}

const TITLE = {
  [TitleVersion.V1]: Phrases.PREMIUM_BENEFITS_TITLE_1,
  [TitleVersion.V2]: Phrases.PREMIUM_BENEFITS_TITLE_2,
  [TitleVersion.V3]: Phrases.PREMIUM_BENEFITS_TITLE_3,
};

interface Props {
  titleVersion: TitleVersion;
  bordered?: boolean;
  animatedVisible?: boolean;
  ctaLabel?: string;
  className?: string;
}

const PremiumBenefits: React.FC<Props> = ({
  titleVersion = TitleVersion.V1,
  bordered = false,
  animatedVisible = false,
  ctaLabel,
  className,
}) => {
  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();

  return (
    <div
      className={classNames(
        styles.premiumBenefits,
        'd-flex flex-col gap-sm flex-ai-c w-100',
        {
          [styles.bordered]: bordered,
        },
        className
      )}>
      <Title
        title={renderTextWithIndexedTags(TITLE[titleVersion], [
          <span key='span-0' />,
        ])}
        className={classNames('text-md fw-bold ta-center', {
          [styles.animatedVisible]: animatedVisible,
        })}
      />
      <BenefitsList animatedVisible={animatedVisible} />
      {ctaLabel && (
        <Button
          onClick={handleOpenSubscriptionPopup}
          appearance={ButtonAppearance.PRIMARY_BORDERED_GRADIENT}
          icon={{
            glyph: IconGlyph.ARROW_RIGHT,
            position: IconPosition.RIGHT,
          }}>
          {ctaLabel}
        </Button>
      )}
    </div>
  );
};

export default PremiumBenefits;
